export const tr = {
    about: 'More info'
};
